import React from 'react';
import PropTypes from 'prop-types';

import { VIEW_SIZE } from 'utils/device';
import Button from 'shared-components/Button/Button';
import styles from './ShareSale.module.css';
import shareSaleImg from './share-sale.png';
import shareSaleImgMobile from './share-sale-mobile.png';

const ShareSale = ({
  title,
  subtitle,
  boxTitle,
  list,
  buttonText,
  viewSize,
  onClickButton,
}) => {
  const image =
    viewSize === VIEW_SIZE.small ? shareSaleImgMobile : shareSaleImg;

  return (
    <div className={styles.container}>
      <img className={styles.image} src={image} alt="" />
      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
        <div
          className={styles.subtitle}
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
        <div className={styles.box}>
          <p className={styles.boxTitle}>{boxTitle}</p>
          <ul className={styles.list}>
            {list.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={index}>
                <div dangerouslySetInnerHTML={{ __html: item }} />
              </li>
            ))}
          </ul>
        </div>
        <Button className={styles.button} onClick={onClickButton}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

ShareSale.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  boxTitle: PropTypes.string.isRequired,
  list: PropTypes.arrayOf(PropTypes.string).isRequired,
  buttonText: PropTypes.string.isRequired,
  viewSize: PropTypes.string.isRequired,
  onClickButton: PropTypes.func.isRequired,
};

export default ShareSale;
